<template>
  <div class="dateTicket" v-if="tickets.length > 0">
    <transition-group name="fade">
      <template v-for="ticket in tickets" :key="ticket.id">
        <DateTicket
          class="ticket"
          :ticket="ticket"
          v-if="doesTicketContainSelectedTime(ticket) && doesTicketContainSelectedGroup(ticket)"
        ></DateTicket>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DateTicket from './DateTicket.vue';

export default {
  name: 'DateTickets',
  components: { DateTicket },
  computed: {
    ...mapState({
      form: (state) => state.tickets.form,
      ticketOrder: (state) => state.tickets.data.order,
      ticketGroups: (state) => state.tickets.data.ticketGroups,
    }),
  },
  props: {
    tickets: { required: true },
  },
  methods: {
    ...mapActions({}),
    doesTicketContainSelectedTime(ticket) {
      if (parseInt(ticket.mode, 10) === 5) {
        return true;
      }
      if (this.form.time === null) {
        return true;
      }
      if (typeof ticket.schedule === 'undefined') {
        return true;
      }
      const matchingSchedule = ticket.schedule.find(
        (timeSlot) => timeSlot.datetime === this.form.time
      );
      if (typeof matchingSchedule !== 'undefined') {
        return true;
      }
      return false;
    },
    doesTicketContainSelectedGroup(ticket) {
      const selectedGroupIds = Object.keys(this.ticketGroups).filter((k) => {
        return this.ticketGroups[k].selected;
      });
      if (
        selectedGroupIds.length === 0 ||
        selectedGroupIds.length === Object.keys(this.ticketGroups).length
      ) {
        return true;
      }

      if (selectedGroupIds.includes(ticket.group_id)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
.ticket:nth-child(odd),
.entryTicket {
  background-color: $secondary-block-color-1;
}

.ticket:nth-child(even) {
  background-color: $secondary-block-color-2;
}

.ticket,
.entryTicket {
  padding-top: $sp;
  padding-bottom: calc($sp/2);
  @extend .row;
  margin-left: 0;
  margin-right: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
.fade-enter, .fade-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  padding: 0;
}
</style>
